import React from 'react'
import {BsFillSendFill} from 'react-icons/bs'
import {IoCallOutline} from 'react-icons/io5'
import check from '../../img/check.png';
import check1 from '../../img/check1.png';
import check2 from '../../img/check2.png';
import Carousel from 'better-react-carousel';
 import './Pricing.css'
import Footer from '../Footer/Footer'; 
import Model from '../Model/Model';
import Header from '../Header/Header';


const Pricing = () => {
  return (
    <>   
    <Header/>
    <section style={{paddingTop:'120px'}}>
     <div className='container'>
      <div className='row'> 
       <div className='col-lg-12 col-md-12 col-sm-12'>   
        
       <h2 className='text-center'>Pricings - Affordable than Anyone, <br/> Efficient than Everyone</h2>
       
       </div> 
      </div>
     </div>
    </section>

    <section>
     <div className='container'>
      <div className='row'>
     <div className='col-lg-6 col-sm-12 m-auto'>
        
     
     <div className='row'>
      
      
     <div className='col-lg-6 col-md-6 col-sm-12 mt-4'>
        
     <div>
        <button type='btn' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#000', color:'#fff', padding:'8px 15px', 
        width:'100%', borderRadius:'8px'}}> <BsFillSendFill className='me-3'/>  Get Started</button>
     </div>
     </div>
      
     <div className='col-lg-6 col-md-6 col-sm-12 mt-4'>
        
     <div>
        <button type='btn' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 15px', 
        width:'100%', borderRadius:'8px', border:'none'}}> <IoCallOutline className='me-3' style={{fontSize:'25px'}}/>  Talk to Us</button>
     </div>
     </div>
     
     </div>
     

     </div>
      </div>
     </div>
    </section>


    <section>
     <div className='container mt-5'>
     <div className='row'>
     <div className='col-lg-12 col-md-12 col-sm-12'> 

     <h3>Select Products</h3>

     </div>
      
     </div>



     <div className='row'>
      <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
      <div className='mt-2' style={{display:'flex', alignItems:'center'}}>
      <input class="form-check-input" type="checkbox" value="" style={{ width:'20px',height:'20px' , color:'red'}}/> 
      <img src={check} alt='img'/>
      </div>
      </div>
      <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
      <div className='mt-2' style={{display:'flex', alignItems:'center'}}>
      <input class="form-check-input me-3" type="checkbox" value="" style={{ width:'20px',height:'20px' , color:'red'}}/> 
      <img src={check1} alt='img'/>
      </div>
      </div>
      <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
      <div className='mt-2' style={{display:'flex', alignItems:'center'}}>
      <input class="form-check-input me-3" type="checkbox" value="" style={{ width:'20px',height:'20px' , color:'red'}}/> 
      <img src={check2} alt='img' style={{width:'80%'}}/>
      </div>
      </div>
     </div>
     </div>


    </section>

    <section>
     <div className='container mt-5'>
      <div className='col-lg-12 col-md-12 col-sm-12'>
         
      <h3>Plans & Pricing</h3> 
       
      </div>
     </div>
    </section>


    <section>
     <div className='container'>
      <div className='row'>
       <div className='col '>
       
      <div className='demo'>  
       <table class="table"  >
   <thead>
     <tr>
       <th scope="col">Features</th>
       <th scope="col " className='text-nowrap'>Free Plan</th>
       <th scope="col">Starter</th>
       <th scope="col">Expert</th>
       <th scope="col">Professional</th>
       <th scope="col">Scaler</th>
       <th scope="col">Enterprise</th>
     </tr>
   </thead>
   <tbody>
     <tr>
       <th scope="row">Cost (One time)</th>
       <td>₹ 0</td>
       <td className='text-nowrap'>₹ 10,000</td>
       <td className='text-nowrap'>₹ 25,000</td>
       <td className='text-nowrap'>₹ 50,000</td>
       <td className='text-nowrap'>₹ 1,00,000</td>
       <td className='text-nowrap'>₹ 2,00,000</td>
     </tr>
     <tr>
       <th scope="row">Free Credits</th>
       <td>25</td>
       <td> 50</td>
       <td>80</td>
       <td>180</td>
       <td>425</td>
       <td>1350</td>
     </tr>
 
     <tr>
       <th scope="row">Cost Per Credit/year</th>
       <td className='text-nowrap' >₹ 499</td>
       <td className='text-nowrap'>₹ 415</td>
       <td className='text-nowrap'>₹ 365</td>
       <td className='text-nowrap'>₹ 295</td>
       <td className='text-nowrap'>₹ 245</td>
       <td className='text-nowrap'>₹ 165</td>
     </tr>
 
 
     <tr>
       <th scope="row">Automatic Attendance</th>
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
 
     <tr>
       <th scope="row">Attendance Machine <br/>
       <span style={{fontSize:'12px'}}>Optional</span> </th>
       <td className='text-nowrap' >₹ 35,000</td> 
       <td className='text-nowrap' >₹ 32,500</td> 
       <td className='text-nowrap' >₹ 30,500</td> 
       <td className='text-nowrap'  >₹ 29,000</td> 
       <td className='text-nowrap' >₹ 26,000</td> 
       <td className='text-nowrap'  >₹ 23,000</td> 
       
     </tr>
 
 
     <tr>
       <th scope="row">Automatic Fees Collection</th>
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
 
 
     
 
     <tr>
       <th scope="row">Kan-Ban Reporting system</th>
       
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
     
 
     
 
     <tr>
       <th scope="row">Online Quiz, Exams</th> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
     
 
     <tr>
       <th scope="row">Student Monitoring</th> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
 
     <tr>
       <th scope="row">Batch Automation</th> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       
     </tr>
 
     <tr>
       <th scope="row">Pre-Recorded Courses</th> 
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Accounts Automation</th>  
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Doubt resolution</th>  
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Sales Management</th>  
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Team Management</th>  
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Inventory Management</th>  
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Vendor Management</th>  
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Payouts</th>  
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Hr & Payroll automation</th>  
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Real Time Analytics</th>   
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Automatic Student Tracking</th>   
       <td  style={{color:'red'}}>No</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
       <th scope="row">Whitelabelling</th>   
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td> 
       <td  style={{color:'#0AC677'}}>Yes</td>  
     </tr>
 
     <tr>
     <th scope="row">Student App ( one-Time )</th>
     <td className='text-nowrap' >₹ 30,000</td> 
     <td className='text-nowrap' >₹ 30,000</td> 
     <td className='text-nowrap' >₹ 30,000</td> 
     <td className='text-nowrap' >₹ 30,000</td> 
     <td className='text-nowrap' >₹ 30,000</td> 
     <td className='text-nowrap' >₹ 30,000</td>  
     
   </tr>
 
 
 
 
   </tbody>
 </table> 
       </div>
       </div>
       
       
       </div>
      </div> 
    </section>
 
    <section>
     <div className='container mt-4'>
      <div className='row'>
      <div className='col-lg-6 col-md-6 col-sm-12 '>
      

      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'  }}>
       <h3>Want custom Pricing?</h3> 

       <button type='btn' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 9px', 
        borderRadius:'8px', border:'none'}}> <IoCallOutline   style={{fontSize:'25px'}}/>  Talk to Us</button>
    </div>

      
      </div>
      
      </div>

     </div>
    </section>


  



   <section className='mt-5'>
    <Footer/>
   </section>






   <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  style={{backdropFilter:'blur(5px)'}}>
   <div class="modal-dialog modal-dialog-centered modal-lg" >
     <div class="modal-content"  style={{paddingTop:'0%'}}>
        

     <div class="modal-body">

           <Model/>
     </div>
       
     </div>
   </div>
 </div>
    </>
  )
}

export default Pricing
